
    import { defineAsyncComponent } from '#imports'
    
import BlokkliComponent_from_library_index from '../../node_modules/@blokkli/editor/dist/runtime/components/Blocks/FromLibrary/index.vue'
import BlokkliComponent_accordion_InsideFooter from '../../components/Paragraph/Accordion/InsideFooter.vue'
import BlokkliComponent_accordion_index from '../../components/Paragraph/Accordion/index.vue'
import BlokkliComponent_address_index from '../../components/Paragraph/Address/index.vue'
import BlokkliComponent_datawrapper_index from '../../components/Paragraph/Datawrapper/index.vue'
import BlokkliComponent_dynamics_365_index from '../../components/Paragraph/Dynamics365/index.vue'
import BlokkliComponent_address_list_index from '../../components/Paragraph/AddressList/index.vue'
import BlokkliComponent_faq_index from '../../components/Paragraph/FAQ/index.vue'
import BlokkliComponent_iframe_index from '../../components/Paragraph/Iframe/index.vue'
import BlokkliComponent_guidle_index from '../../components/Paragraph/Guidle/index.vue'
import BlokkliComponent_image_InsideSlider from '../../components/Paragraph/Image/InsideSlider.vue'
import BlokkliComponent_image_index from '../../components/Paragraph/Image/index.vue'
import BlokkliComponent_issuu_index from '../../components/Paragraph/Issuu/index.vue'
import BlokkliComponent_link_AsSocialLinks from '../../components/Paragraph/Link/AsSocialLinks.vue'
import BlokkliComponent_link_index from '../../components/Paragraph/Link/index.vue'
import BlokkliComponent_logo_index from '../../components/Paragraph/Logo/index.vue'
import BlokkliComponent_logo_list_index from '../../components/Paragraph/LogoList/index.vue'
import BlokkliComponent_remote_video_index from '../../components/Paragraph/RemoteVideo/index.vue'
import BlokkliComponent_quote_index from '../../components/Paragraph/Quote/index.vue'
import BlokkliComponent_teaser_index from '../../components/Paragraph/Teaser/index.vue'
import BlokkliComponent_slider_index from '../../components/Paragraph/Slider/index.vue'
import BlokkliComponent_teaser_InsideMenu from '../../components/Paragraph/Teaser/InsideMenu.vue'
import BlokkliComponent_text_index from '../../components/Paragraph/Text/index.vue'
import BlokkliComponent_text_InsideSlider from '../../components/Paragraph/Text/InsideSlider.vue'
import BlokkliComponent_teaser_list_index from '../../components/Paragraph/TeaserList/index.vue'
import BlokkliComponent_text_image_box_index from '../../components/Paragraph/TextImageBox/index.vue'
import BlokkliComponent_title_index from '../../components/Paragraph/Title/index.vue'
import BlokkliComponent_toggle_index from '../../components/Paragraph/Toggle/index.vue'
import BlokkliComponent_toggle_item_index from '../../components/Paragraph/ToggleItem/index.vue'
import BlokkliComponent_two_columns_index from '../../components/Paragraph/TwoColumns/index.vue'
import BlokkliComponent_video_index from '../../components/Paragraph/Video/index.vue'
import BlokkliComponent_webcam_index from '../../components/Paragraph/Webcam/index.vue'
import BlokkliComponent_blokkli_fragment_index from '../../node_modules/@blokkli/editor/dist/runtime/components/Blocks/Fragment/index.vue'

const global: Record<string, any> = {
  block_from_library: BlokkliComponent_from_library_index,
  block_accordion__field_list_type_footer: BlokkliComponent_accordion_InsideFooter,
  block_accordion: BlokkliComponent_accordion_index,
  block_address: BlokkliComponent_address_index,
  block_datawrapper: BlokkliComponent_datawrapper_index,
  block_dynamics_365: BlokkliComponent_dynamics_365_index,
  block_address_list: BlokkliComponent_address_list_index,
  block_faq: BlokkliComponent_faq_index,
  block_iframe: BlokkliComponent_iframe_index,
  block_guidle: BlokkliComponent_guidle_index,
  block_image__parent_block_slider: BlokkliComponent_image_InsideSlider,
  block_image: BlokkliComponent_image_index,
  block_issuu: BlokkliComponent_issuu_index,
  block_link__field_list_type_socialLinks: BlokkliComponent_link_AsSocialLinks,
  block_link: BlokkliComponent_link_index,
  block_logo: BlokkliComponent_logo_index,
  block_logo_list: BlokkliComponent_logo_list_index,
  block_remote_video: BlokkliComponent_remote_video_index,
  block_quote: BlokkliComponent_quote_index,
  block_teaser: BlokkliComponent_teaser_index,
  block_slider: BlokkliComponent_slider_index,
  block_teaser__field_list_type_menu: BlokkliComponent_teaser_InsideMenu,
  block_text: BlokkliComponent_text_index,
  block_text__parent_block_slider: BlokkliComponent_text_InsideSlider,
  block_teaser_list: BlokkliComponent_teaser_list_index,
  block_text_image_box: BlokkliComponent_text_image_box_index,
  block_title: BlokkliComponent_title_index,
  block_toggle: BlokkliComponent_toggle_index,
  block_toggle_item: BlokkliComponent_toggle_item_index,
  block_two_columns: BlokkliComponent_two_columns_index,
  block_video: BlokkliComponent_video_index,
  block_webcam: BlokkliComponent_webcam_index,
  block_blokkli_fragment: BlokkliComponent_blokkli_fragment_index
}

    
import BlokkliFragmentComponent_anchor_navigation from '../../components/Paragraph/BlokkliFragment/AnchorNavigation/index.vue'

const globalFragments: Record<string, any> = {
  fragment_anchor_navigation: BlokkliFragmentComponent_anchor_navigation
}


const chunks: Record<string, () => Promise<any>> = {
  rare: () => import('./chunk-rare')
}

const chunkMapping: Record<string, string> = {
  "block_tomas": "rare",
  "block_webform": "rare"
}

const fragmentChunkMapping: Record<string, string> = {
  "fragment_countdown": "rare",
  "fragment_mailchimp_signup_form": "rare",
  "fragment_ostendis_jobs": "rare",
  "fragment_tomas_shop": "rare",
  "fragment_tours_search_form": "rare",
  "fragment_team_list": "rare",
  "fragment_zurich_card_widget": "rare"
}

function componentOrFunction(component: any) {
  if (typeof component === 'object') {
    return component
  }

  return defineAsyncComponent(() => component())
}

export function getBlokkliItemComponent(bundle: string, fieldListType?: string, parentBundle?: string): any {
  const forFieldListType = 'block_' + bundle + '__field_list_type_' + fieldListType
  if (global[forFieldListType]) {
    return componentOrFunction(global[forFieldListType])
  }
  if (parentBundle) {
    const forParentBundle = 'block_' + bundle + '__parent_block_' + parentBundle
    if (global[forParentBundle]) {
      return componentOrFunction(global[forParentBundle])
    }
  }
  const key = 'block_' + bundle
  if (global[key]) {
    return componentOrFunction(global[key])
  }
  const chunkName = chunkMapping[key]
  if (chunkName) {
    return defineAsyncComponent(() => chunks[chunkName]().then(chunk => {
      return chunk.default[key]
    }))
  }
}

export function getBlokkliFragmentComponent(name: string): any {
  const key = 'fragment_' + name
  if (globalFragments[key]) {
    return componentOrFunction(globalFragments[key])
  }
  const chunkName = fragmentChunkMapping[key]
  if (chunkName) {
    return defineAsyncComponent(() => chunks[chunkName]().then(chunk => {
      return chunk.default[key]
    }))
  }
}
